import Vue from 'vue';
import Router from 'vue-router';
import addBalance from '@/components/add-balance';
import history from '@/components/history';
import { balance } from '../plugins/WalletAPI';
import store from '../store';

Vue.use(Router);

const
	authGuard = (to, from, next) => {
		if (store.state.userData) {
			next();
		} else {
			balance()
				.then((response) => {
					store.commit('setUserData', response.data);
					next();
				})
				.catch((error) => {
					console.log(error);
				});
		}
	},
	router = new Router({
		mode: 'history',
		base: '/wallet/',
		routes: [
			{
				path: '/:locale/add-balance',
				name: 'add-balance',
				component: addBalance,
				props: true,
				beforeEnter: authGuard
			},
			{
				path: '/:locale/history',
				name: 'purchase-history',
				component: history,
				props: true,
				beforeEnter: authGuard
			},
			{
				path: '/:locale/*',
				name: 'default',
				redirect: to => ({
					path: '/:locale/add-balance',
					query: to.query
				})
			},
			{
				path: '/:locale',
				name: 'default-2',
				redirect: to => ({
					path: '/:locale/add-balance',
					query: to.query
				})
			},
		]
	});

router.beforeEach((to, from, next) => {
	const
		appType = to.query.app_type,
		prodId = to.query.product_id,
		sandBoxMode = to.query.sandbox;

	if (appType) {
		store.commit('setAppType', appType);
	}
	if (prodId) {
		Vue.cookie.set('CommerceProdId', prodId);
		store.commit('setProductId', prodId);
	}
	if (sandBoxMode === 'true') {
		store.commit('enableSandboxMode');
	}

	document.body.className = store.state.appType.toLowerCase();

	next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js